$(() => {
  const fleet_type = () => $('input[name="fleet_type"]:checked').val();

  const tier = () => $('#tier').val();

  const national_fee_per_truck = () => {
    if (fleet_type() === 'trucking') {
      switch (tier()) {
        case 'foundation': return 3.5;
        case 'coverage': return 4;
        case 'advanced': return 5.5;
        default: return 3.5;
      }
    }

    switch (tier()) {
      case 'foundation': return 2.25;
      case 'coverage': return 2.75;
      case 'advanced': return 3.75;
      default: return 2.25;
    }
  };

  const regional_fee_per_truck = () => {
    if (fleet_type() === 'trucking') {
      switch (tier()) {
        case 'foundation': return 2.5;
        case 'coverage': return 3;
        case 'advanced': return 4.5;
        default: return 2.5;
      }
    }

    switch (tier()) {
      case 'foundation': return 1.5;
      case 'coverage': return 2;
      case 'advanced': return 3;
      default: return 1.5;
    }
  };

  const annual_service_fees = () => {
    const number_of_trucks_regional = parseInt($('#number-of-trucks-regional').val().replace(',', ''), 10);
    const number_of_trucks_national = parseInt($('#number-of-trucks-national').val().replace(',', ''), 10);
    const number_of_trailers = parseInt($('#number-of-trailers').val().replace(',', ''), 10);

    const regional_truck_fee = number_of_trucks_regional * regional_fee_per_truck();
    const national_truck_fee = number_of_trucks_national * national_fee_per_truck();
    const trailer_fee = number_of_trailers * 0.25;

    return regional_truck_fee + national_truck_fee + trailer_fee;
  };

  const run = () => {
    const cost = annual_service_fees();

    if ($('#monthly-service-fee-overridden').val() === '0') {
      $('#monthly-service-fee').val(accounting.formatMoney(cost, '', 0));
    }
  };

  run();

  $('#number-of-trucks-regional, #number-of-trucks-national, #number-of-trailers, #tier').blur(() => {
    run();
  });

  $('input[name="fleet_type"]').change(() => {
    run();
  });

  $('#monthly-service-fee').blur(() => {
    $('#monthly-service-fee-overridden').val('1');
  });
});
